/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i2 from '@angular/material';
import * as i3 from '@angular/router';
import * as i4 from '@angular/common';
import * as i5 from '@angular/cdk';
import * as i6 from '../../../../app/containers/home/home.component';
import * as i7 from '@ngx-translate/core/src/translate.service';
const styles_HomeComponent:any[] = ([] as any[]);
export const RenderType_HomeComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_HomeComponent,data:{}});
export function View_HomeComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),33,'md-card',[['class',
      'mat-card']],(null as any),(null as any),(null as any),i1.View_MdCard_0,i1.RenderType_MdCard)),
      i0.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],
          i0.ElementRef],(null as any),(null as any)),i0.ɵdid(49152,(null as any),
          0,i2.MdCard,([] as any[]),(null as any),(null as any)),(_l()(),i0.ɵted(0,
          ['\n  '])),(_l()(),i0.ɵeld(0,(null as any),0,8,'md-card-header',[['class',
          'mat-card-header']],(null as any),(null as any),(null as any),i1.View_MdCardHeader_0,
          i1.RenderType_MdCardHeader)),i0.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i0.ElementRef],(null as any),(null as any)),
      i0.ɵdid(49152,(null as any),0,i2.MdCardHeader,([] as any[]),(null as any),(null as any)),
      (_l()(),i0.ɵted(2,['\n    '])),(_l()(),i0.ɵeld(0,(null as any),1,3,'md-card-title',
          [['class','mat-card-title ']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i0.ElementRef],(null as any),(null as any)),
      i0.ɵdid(16384,(null as any),0,i2.MdCardTitle,([] as any[]),(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),['Software Downloads'])),(_l()(),i0.ɵted(2,['\n  '])),
      (_l()(),i0.ɵted(0,['\n  '])),(_l()(),i0.ɵeld(0,(null as any),0,3,'md-card-content',
          [['class','mat-card-content']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i0.ElementRef],(null as any),(null as any)),
      i0.ɵdid(16384,(null as any),0,i2.MdCardContent,([] as any[]),(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),['\n    Get the latest software for your Subsite product.\n  '])),
      (_l()(),i0.ɵted(0,['\n  '])),(_l()(),i0.ɵeld(0,(null as any),0,0,'br',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(0,['\n  '])),(_l()(),i0.ɵeld(0,(null as any),0,11,'md-card-actions',
          [['class','mat-card-actions']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.MdPrefixRejector,
          [[2,i2.MATERIAL_COMPATIBILITY_MODE],i0.ElementRef],(null as any),(null as any)),
      i0.ɵdid(16384,(null as any),0,i2.MdCardActions,([] as any[]),(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          6,'a',[['class','mat-raised-button'],['color','primary'],['md-raised-button',
              '']],[[1,'target',0],[8,'href',4],[1,'disabled',0],[1,'aria-disabled',
              0],[8,'tabIndex',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,26).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            if (('click' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,29)._haltDisabledEvents($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i1.View_MdAnchor_0,i1.RenderType_MdAnchor)),i0.ɵdid(671744,(null as any),
          0,i3.RouterLinkWithHref,[i3.Router,i3.ActivatedRoute,i4.LocationStrategy],
          {routerLink:[0,'routerLink']},(null as any)),i0.ɵpad(1),i0.ɵdid(16384,(null as any),
          0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i0.ElementRef],
          (null as any),(null as any)),i0.ɵdid(180224,(null as any),0,i2.MdAnchor,
          [i5.Platform,i2.FocusOriginMonitor,i0.ElementRef,i0.Renderer2],{color:[0,
              'color']},(null as any)),i0.ɵdid(16384,(null as any),0,i2.MdRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i0.ɵted(0,['Products'])),
      (_l()(),i0.ɵted((null as any),['\n  '])),(_l()(),i0.ɵted(0,['\n'])),(_l()(),
          i0.ɵted((null as any),['\n']))],(_ck,_v) => {
    const currVal_5:any = _ck(_v,27,0,'/products');
    _ck(_v,26,0,currVal_5);
    const currVal_6:any = 'primary';
    _ck(_v,29,0,currVal_6);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,26).target;
    const currVal_1:any = i0.ɵnov(_v,26).href;
    const currVal_2:any = (i0.ɵnov(_v,29).disabled || (null as any));
    const currVal_3:any = i0.ɵnov(_v,29).disabled.toString();
    const currVal_4:any = i0.ɵnov(_v,29).tabIndex;
    _ck(_v,25,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
  });
}
export function View_HomeComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'app-home',([] as any[]),
      (null as any),(null as any),(null as any),View_HomeComponent_0,RenderType_HomeComponent)),
      i0.ɵdid(114688,(null as any),0,i6.HomeComponent,[i7.TranslateService],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const HomeComponentNgFactory:i0.ComponentFactory<i6.HomeComponent> = i0.ɵccf('app-home',
    i6.HomeComponent,View_HomeComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL0NsaWVudC9hcHAvY29udGFpbmVycy9ob21lL2hvbWUuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2Q6L2EvMS9zL1NvZnR3YXJlTWFuYWdlci9DbGllbnQvYXBwL2NvbnRhaW5lcnMvaG9tZS9ob21lLmNvbXBvbmVudC50cyIsIm5nOi8vL2Q6L2EvMS9zL1NvZnR3YXJlTWFuYWdlci9DbGllbnQvYXBwL2NvbnRhaW5lcnMvaG9tZS9ob21lLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL0NsaWVudC9hcHAvY29udGFpbmVycy9ob21lL2hvbWUuY29tcG9uZW50LnRzLkhvbWVDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bWQtY2FyZD5cclxuICA8bWQtY2FyZC1oZWFkZXI+XHJcbiAgICA8bWQtY2FyZC10aXRsZT5Tb2Z0d2FyZSBEb3dubG9hZHM8L21kLWNhcmQtdGl0bGU+XHJcbiAgPC9tZC1jYXJkLWhlYWRlcj5cclxuICA8bWQtY2FyZC1jb250ZW50PlxyXG4gICAgR2V0IHRoZSBsYXRlc3Qgc29mdHdhcmUgZm9yIHlvdXIgU3Vic2l0ZSBwcm9kdWN0LlxyXG4gIDwvbWQtY2FyZC1jb250ZW50PlxyXG4gIDxiciAvPlxyXG4gIDxtZC1jYXJkLWFjdGlvbnM+XHJcbiAgICA8YSBtZC1yYWlzZWQtYnV0dG9uIFtyb3V0ZXJMaW5rXT1cIlsnL3Byb2R1Y3RzJ11cIiBjb2xvcj1cInByaW1hcnlcIj5Qcm9kdWN0czwvYT5cclxuICA8L21kLWNhcmQtYWN0aW9ucz5cclxuPC9tZC1jYXJkPlxyXG4iLCI8YXBwLWhvbWU+PC9hcHAtaG9tZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO2FBQUE7dUJBQUEsc0NBQUE7VUFBQSx1REFBUztVQUFBLFdBQ1A7VUFBQTtvQ0FBQSxVQUFBO1VBQUE7YUFBQTtNQUFnQiwrQkFDZDtVQUFBO1VBQUEscUNBQUE7VUFBQTthQUFBO01BQWUsdURBQWtDO01BQ2xDLDZCQUNqQjtVQUFBO1VBQUEscUNBQUE7VUFBQTthQUFBO01BQWlCO01BRUMsNkJBQ2xCO1VBQUE7TUFBTSw2QkFDTjtVQUFBO1VBQUEscUNBQUE7VUFBQTthQUFBO01BQWlCLDJDQUNmO1VBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2tCQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSxxREFBQTtVQUFBO1VBQUEsb0RBQW9CLFdBQXBCO1VBQUE7VUFBQSxvQ0FBQTtVQUFBO2NBQUEsZ0NBQUE7VUFBQSwyQ0FBaUU7TUFBWSx5Q0FDN0QsMkJBQ1Y7aUJBQUE7SUFGYztJQUFwQixZQUFvQixTQUFwQjtJQUFpRDtJQUFqRCxZQUFpRCxTQUFqRDs7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsWUFBQSxvQkFBQSw2QkFBQTs7OztvQkNUSjtNQUFBO2FBQUE7VUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./Client/$$_gendir/app/containers/home/home.component.ngfactory.ts